import type {ComponentProps} from 'react';
import type {ResponsiveHeader} from '../..';
import styles from './popular-keywords.module.css';

const searchUrl = (keyword: string) =>
  `/main/action.php?run=html&page=searchkey&search_word=${encodeURIComponent(
    keyword,
  )}&search_pattern=1`;

type Props = Pick<ComponentProps<typeof ResponsiveHeader>, 'popularKeywords'>;

export function PopularKeywords({popularKeywords}: Props) {
  if (popularKeywords === undefined) return false;

  return (
    <div className={styles.keyword}>
      <h2 className={styles.keywordTitle}>人気のキーワード</h2>
      <ul className={styles.keywordList}>
        {popularKeywords.map((keyword) => (
          <li key={keyword.kijinetaTagId} className={styles.keywordItem}>
            <a href={searchUrl(keyword.kijinetaTag)}>{keyword.kijinetaTag}</a>
          </li>
        ))}
      </ul>
    </div>
  );
}
